import React from 'react';
import Particles from 'react-particles-js';
import particlesConfig from '../data/particlesjsConfig';

const Banner = ({ title }) => {
  return (
    <div className="banner banner-bg h-60 md:h-72 lg:h-80 mx-auto">
      <h3 className="banner-text p-4 lg:p-12 text-xl md:text-4xl font-bold text-primary bg-white">
        {title}
      </h3>
      <Particles
        params={particlesConfig}
        className="App-particles__container z-0"
      />
    </div>
  );
};

export default Banner;
